import styled from "styled-components";

const CardFormacao = styled.div`
  border-radius: 8px;
  margin-bottom: 30px;
  background-color: var(--white);
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
`;

export default CardFormacao;
